/** 助手 tool_payload.image_previews（引用图片素材后的缩略图摘要）。 */
export type HermesMaterialImagePreview = {
  id: number;
  slug: string;
  name?: string | null;
  notes?: string | null;
};

function coercePositiveInt(value: unknown): number | null {
  if (typeof value === "number" && Number.isFinite(value) && value > 0) {
    return Math.trunc(value);
  }
  if (typeof value === "string" && /^\d+$/.test(value.trim())) {
    const n = Number(value.trim());
    return n > 0 ? n : null;
  }
  return null;
}

function parseOnePreview(entry: unknown): HermesMaterialImagePreview | null {
  if (!entry || typeof entry !== "object") return null;
  const record = entry as Record<string, unknown>;
  const id = coercePositiveInt(record.id);
  if (id == null) return null;
  if (typeof record.slug !== "string" || record.slug.trim() === "") return null;

  const preview: HermesMaterialImagePreview = {
    id,
    slug: record.slug.trim(),
  };
  if (record.name === null || typeof record.name === "string") {
    preview.name = record.name;
  }
  if (record.notes === null || typeof record.notes === "string") {
    preview.notes = record.notes;
  }
  return preview;
}

/**
 * 从助手 tool_payload 解析素材缩略图列表。
 * 支持 `image_previews` 数组，以及单条 `image_preview`。
 */
export function hermesMessageImagePreviewsFromPayload(
  toolPayload: Record<string, unknown> | null | undefined,
): HermesMaterialImagePreview[] {
  if (!toolPayload) return [];

  const out: HermesMaterialImagePreview[] = [];
  const seen = new Set<string>();

  const push = (entry: unknown) => {
    const preview = parseOnePreview(entry);
    if (!preview) return;
    const key = preview.slug;
    if (seen.has(key)) return;
    seen.add(key);
    out.push(preview);
  };

  const list = toolPayload.image_previews;
  if (Array.isArray(list)) {
    for (const entry of list) push(entry);
  }

  push(toolPayload.image_preview);
  return out;
}
